import DomainsSearchView from '../views/domainsSearch.view.html?raw';

class DomainSearchController {
    constructor(sharedData) {
        this.sharedData = sharedData;
    }

    $onInit() {
        this.extensions = JSON.parse(this.extensions);
        if (this.extensions && this.extensions.length > 0) {
            this.sharedData.selectedTlds = this.extensions;
        } else if (this.additionalSelectedTlds && JSON.parse(this.additionalSelectedTlds)) {
            const additionalSelectedTlds = JSON.parse(this.additionalSelectedTlds);
            this.sharedData.selectedTlds = this.sharedData.selectedTlds.concat(additionalSelectedTlds);
        }

        this._cleanPhrase();
        this.search(false);
    }

    $onChanges(changes) {
        if (changes.phrase && !changes.phrase.isFirstChange()) {
            this._cleanPhrase();
        }
    }

    search(sendGaEvent = true) {
        if (sendGaEvent) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'button_SearchDomain',
                buttonLocation: 'angularComponent'
            });
        }

        this._cleanPhrase();
        this.sharedData.searchParam = this.phrase.toLowerCase();
    }

    _cleanPhrase() {
        if (typeof this.phrase !== 'string') {
            return;
        }

        let value = this.phrase;

        // Usuwamy wszystkie znaki, które nie są
        // - literą Unicode (\p{L})
        // - cyfrą Unicode (\p{N})
        // - kropką (.)
        // - myślnikiem (-)
        value = value.replace(/[^\p{L}\p{N}\.\-]/gu, '');

        // Usuwamy kropkę na początku
        if (value.startsWith('.')) {
            value = value.slice(1);
        }

        // Usuwamy myślnik na początku
        const parts = value.split('.');
        for (let i = 0; i < parts.length; i++) {
            parts[i] = parts[i].replace(/^-+/, '');
        }

        value = parts.join('.');

        // Usuwamy wystąpienia podwójnych (lub więcej) kropek
        while (value.includes('..')) {
            value = value.replace(/\.{2,}/g, '.');
        }

        // Usuwamy wystąpienia podwójnych (lub więcej) myślników
        while (value.includes('--')) {
            value = value.replace(/-{2,}/g, '-');
        }

        this.phrase = value;
    }
}

let domainSearchComponent = {
    bindings: {
        phrase: '<',
        extensions: '<',
        additionalSelectedTlds: '<'
    },
    template: DomainsSearchView,
    controller: DomainSearchController
};

DomainSearchController.$inject = ['sharedData'];
export default domainSearchComponent;
